import { useCallback, useRef } from 'react';

import { AppStateStatus } from 'react-native';

import { useUpdateOnAppStateChange } from 'hooks/use-update-on-app-state-change';
import { routes } from 'navigation/routing/routes';

export const isGiftCardBalanceVisibleRoute = (pathname: string) =>
  pathname === routes.payment || pathname === routes.cartCheckout;

export const useAppStateRefresh = (
  markPaymentMethodsStale: () => void,
  cognitoId: string | undefined
) => {
  const wasBackgrounded = useRef(false);

  const handleAppStateChange = useCallback(
    (appStateStatus: AppStateStatus) => {
      if (appStateStatus === 'background') {
        wasBackgrounded.current = true;
        return;
      }

      if (appStateStatus !== 'active') {
        return;
      }

      if (wasBackgrounded.current && cognitoId) {
        markPaymentMethodsStale();
      }

      wasBackgrounded.current = false;
    },
    [markPaymentMethodsStale, cognitoId]
  );

  useUpdateOnAppStateChange(handleAppStateChange);
};
